import { render, staticRenderFns } from "./RegisterFull.vue?vue&type=template&id=30fd54ea&"
import script from "./RegisterFull.vue?vue&type=script&lang=js&"
export * from "./RegisterFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports